import { load } from './Controllers/BaseController';
import SliderController from './Controllers/SliderController';
import MessageController from './Controllers/MessageController';
import MailListSubscribeController from './Controllers/MailListSubscribeController';
import ListController from './Controllers/ListController';
import FormController from './Controllers/FormController';
import ExpandableWindowController from './Controllers/ExpandableWindowController';


export default load([MessageController, SliderController, MailListSubscribeController, ListController, FormController, ExpandableWindowController]);
